<template>
    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-12 col-sm-3">
                    <div class="placeholder-box" style="width:100%;height:30px;margin-bottom: 15px;"></div>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <div class="placeholder-box" style="width:100%;height:32px;margin-bottom: 15px;" 
                         v-bind:class="{ 'hidden': mobile !== true && weekMode !== true }"></div>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <div class="placeholder-box" v-if="admin" style="width:100%;height:68px;margin-bottom: 18px;"></div>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <div class="placeholder-box" style="width:100%;height:46px;margin-bottom: 15px;"></div>
                </div>
                <div class="col-xs-12" 
                        v-bind:class="{'hidden': mobile === true}">
                    <div class="placeholder-box" style="width:100%;height:250px;margin-bottom: 20px;"></div>
                </div>
            </div>
        </div>
        <div class="col-xs-12">
            <div class="placeholder-box" style="width:100%;height:400px;margin-bottom: 20px;"></div>
        </div>
        <div class="col-xs-12" 
                v-bind:class="{'hidden': mobile !== true}">
            <div class="placeholder-box" style="width:100%;height:250px;"></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            weekMode: 'reservations/weekMode',
            loggedIn: 'common/loggedIn',
            admin: 'common/admin',
            adminMode: 'common/adminMode',
            mobile: 'common/mobile',
        }),
    }
}
</script>